export default __webpack_public_path__ + "static/media/peso.a9c5ca5a.svg";